import { render } from "./topImgManagement.vue?vue&type=template&id=1dbc9cba"
import script from "./topImgManagement.vue?vue&type=script&lang=js"
export * from "./topImgManagement.vue?vue&type=script&lang=js"

import "./topImgManagement.vue?vue&type=style&index=0&id=1dbc9cba&lang=less"
script.render = render

export default script